import { Box, Avatar, Tooltip } from "@mui/material";
import { UserBadge, Badge } from "types/badge";

type BadgeDisplayProps = {
  badges: UserBadge[];
  size?: "small" | "medium" | "large";
  onBadgeClick?: (badge: Badge) => void;
};

export const BadgeDisplay: React.FC<BadgeDisplayProps> = ({
  badges,
  size = "small",
  onBadgeClick,
}) => {
  const avatarSize = size === "small" ? 32 : size === "medium" ? 40 : 48;

  if (!badges || badges.length === 0) {
    return null;
  }

  const sortedBadges = [...badges].sort(
    (a, b) => (a.badge?.criteria_value ?? 0) - (b.badge?.criteria_value ?? 0)
  );

  const handleBadgeClick = (badge: Badge | null | undefined) => {
    if (badge && onBadgeClick) {
      onBadgeClick(badge);
    }
  };

  return (
    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      {sortedBadges.map((userBadge) => (
        <Tooltip
          key={userBadge.user_badge_id}
          title={userBadge.badge?.name || ""}
          arrow
        >
          <Avatar
            src={userBadge.badge?.icon_url || undefined}
            alt={userBadge.badge?.name || ""}
            onClick={() => handleBadgeClick(userBadge.badge)}
            sx={{
              width: avatarSize,
              height: avatarSize,
              border: "2px solid",
              borderColor: "primary.main",
              cursor: onBadgeClick ? "pointer" : "default",
              transition: "transform 0.2s ease-in-out",
              "&:hover": onBadgeClick
                ? {
                    transform: "scale(1.1)",
                  }
                : {},
            }}
          >
            {userBadge.badge?.name?.charAt(0) || ""}
          </Avatar>
        </Tooltip>
      ))}
    </Box>
  );
};
